export default __webpack_public_path__ + "static/media/leftArrowSVG.40d1c2e2.svg";